// 메인 페이지 전용 기능 초기화
function initializeMainPage() {
    // DOM 준비 후 실행할 코드
    const headerLogo = document.querySelector('h1.m-header__logo');
    setTimeout(() => {
        headerLogo.style = 'position:relative;';
    }, 2500);
}

// DOM 로드 후 실행
document.addEventListener('DOMContentLoaded', function () {
    initializeMainPage();
});